
// For Segment and GA event racking
const trackEvent = (action, step, bulk, setting=null) => {
  if (window.Edu && window.Edu.trackEvent) {
    window.Edu.trackEvent('myStudents',
      {
        action: action,
        step: step,
        bulk: bulk,
        setting: setting
      },
      {
        eventCategory: 'my-students',
        eventAction: action + (bulk ? '-bulk' : ''),
        eventLabel: step
      }
    );
  }
}

export default trackEvent;
